import { getEndpoint } from '@/ui/core/config'
import { GuestbookEvent, GuestbookEventSchema } from '@/shared/types'
import { GuestbookClient } from '../GuestbookClient'

export async function getEvent(
  this: GuestbookClient,
  eventId: string,
): Promise<GuestbookEvent | undefined> {
  const params = new URLSearchParams({ id: eventId }).toString()
  const result = await fetch(`${getEndpoint('events')}?${params}`, {
    method: 'GET',
  })

  try {
    const event = GuestbookEventSchema.parse(await result.json())
    return event
  } catch (err) {
    console.warn('Failure to parse event', err)
    return undefined
  }
}
